// ✅ Save Token in LocalStorage
export const saveToken = (token: string) => {
    localStorage.setItem("USER_TOKEN", token);
  };
  
  // ✅ Get Token from LocalStorage
  export const getToken = () => {
    return localStorage.getItem("USER_TOKEN");
  };
  
  // ✅ Remove Token (Logout)
  export const logout = () => {
    localStorage.removeItem("USER_TOKEN");
    window.location.href = "/"; // Redirect to login page
  };
  
  // ✅ Check if User is Authenticated
  export const isAuthenticated = () => {
    return !!localStorage.getItem("USER_TOKEN");
  };
  